@if (cognitoUser) {
	<div>
		@if (loading()) {
			<nz-spin nzSimple nzSize="large"></nz-spin>
		}
		@if (!loading()) {
			<h2>ID / E-Mail</h2>
			<table>
				@if (metabiUser()) {
					<tr>
						<td>Mira UUID:</td>
						<td>{{ metabiUser()!.uuid }}</td>
					</tr>
				}
				<tr>
					<td>Cognito username:</td>
					<td>{{ cognitoUser.username }}</td>
				</tr>
				<tr>
					<td>Cognito UUID:</td>
					<td>{{ cognitoUser.uuid }}</td>
				</tr>
				@if (cognitoUser.email) {
					<tr>
						<td>Cognito E-Mail:</td>
						<td>{{ cognitoUser.email }}</td>
					</tr>
				}
				<tr>
					<td>Cognito Status:</td>
					<td>
						<span
							[class.confirmed-status]="isConfirmedUserStatus()"
							[class.pending-status]="!isConfirmedUserStatus()"
						>
							{{ getFormattedConfirmationStatus() }}
						</span>
					</td>
				</tr>
			</table>

			@if (metabiUser(); as metabiUser) {
				<hr />

				<div class="active-date-range">
					<div>
						<label>Active Start Date:</label>
						<nz-date-picker
							[(ngModel)]="metabiUser.active_start_date"
							nzPlaceHolder="Start Date"
							[nzAllowClear]="true"
						></nz-date-picker>
					</div>
					<div>
						<label>Active End Date:</label>
						<nz-date-picker
							[(ngModel)]="metabiUser.active_end_date"
							nzPlaceHolder="End Date"
							[nzAllowClear]="true"
						></nz-date-picker>
					</div>
				</div>

				<div class="active-checkbox">
					<label nz-checkbox [(ngModel)]="metabiUser.active">Active</label>
				</div>
				<hr />

				<div class="locked-checkbox">
					<label nz-checkbox [(ngModel)]="metabiUser.account_locked">Account Locked</label>
				</div>
				<hr />
			}

			<br />
			<h2>Client</h2>
			<app-clients-selector
				[selectedClientUuids]="selectedClientUuids()"
				(onChange)="onClientsChanged($event)"
			></app-clients-selector>

			<br />
			<h2>Groups</h2>
			<app-cognito-group-selector
				[allGroups]="groups()"
				[selectedGroups]="selectedGroups()"
				(onChange)="onGroupsChanged($event)"
			></app-cognito-group-selector>

			<br />
			@if (selectedGroups().includes(Role.SCHOOL_ADMIN)) {
				<h2>Locations</h2>
				<app-locations-selector
					[selectedClients]="selectedClients()"
					[selectedLocationUuids]="selectedLocationUuids()"
					(onChange)="onLocationsChanged($event)"
				></app-locations-selector>
				<br />
			}

			<h2>Sections</h2>
			<app-sections-selector
				[selectedClients]="selectedClients()"
				[selectedSectionUuids]="selectedSectionUuids()"
				(onChange)="onSectionsChanged($event)"
			></app-sections-selector>

			<div class="buttons">
				<button
					nz-button
					nzType="primary"
					type="submit"
					(click)="onSubmit$()"
					[disabled]="!hasRequiredSelections()"
				>
					Submit
				</button>
			</div>
		}
	</div>
}
